<ng-template #brandInfoTemplate>
	@if (brandInfo(); as brandInfo) {
	<lib-card [avatar]="brandInfo.brandAvatar" [subtitle]="'Your coach'" [title]="brandInfo.name">
		@if (brandInfo.bio?.length) {
		<div class="push-bottom" libText3>
			{{ brandInfo.bio }}
		</div>
		} @if (brandInfo.tableItems.length) {
		<div class="push-bottom">
			<ui-simple-table [items]="brandInfo.tableItems"></ui-simple-table>
		</div>
		}

		<div>
			<lib-button-list [buttons]="trainerButtons()"></lib-button-list>
		</div>
	</lib-card>
	}
</ng-template>

@if (showInstallOnDashboard()) {
<lib-message [dismissId]="'DashboardInstall'" [type]="'tip'" [title]="'Install app'" [className]="'push-bottom-md'">
	<div>Get the most from the app by using it on your phone / tablet.</div>

	<div class="push-top-sm">
		<mod-install-button [buttonType]="'basic'"></mod-install-button>
	</div>
</lib-message>
}

<div [libFlexRow]="isMobileOrTabletView()" [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		@if (showBrandInfo() && brandInfoBoxLocation() === 'left') {
		<div class="push-bottom-md">
			<ng-template [ngTemplateOutlet]="brandInfoTemplate"></ng-template>
		</div>
		} @if (commonDashboardData(); as commonDashboardData) {

		<lib-card [title]="'Training plan'">
			@if (commonDashboardData.training) { You have been assigned
			<lib-link [displayStyle]="'inline'" [routerLink]="commonDashboardData.training.routerLink">{{
				commonDashboardData.training.planName
			}}</lib-link>
			training plan

			<div class="push-top">
				<lib-button-list [buttons]="trainingPlanButtons()"></lib-button-list>
			</div>
			} @else {
			<lib-message [type]="'noData'">You have no assigned training plan</lib-message>
			}
		</lib-card>

		<lib-card [title]="'Nutrition plan'" class="push-top-md">
			@if (commonDashboardData.nutrition) { You have been assigned
			<lib-link [displayStyle]="'inline'" [routerLink]="commonDashboardData.nutrition.routerLink">
				{{ commonDashboardData.nutrition.planName }}</lib-link
			>
			nutrition plan
			<div class="push-top">
				<lib-button-list [buttons]="nutritionPlanButtons()"></lib-button-list>
			</div>
			} @else {
			<lib-message [type]="'noData'">You have no assigned nutrition plan</lib-message>
			}
		</lib-card>
		}

		<lib-card class="push-top-md" [title]="'Tasks'" [titleSuffix]="'(' + assignedTasks()?.length + ')'">
			<lib-list
				[showNameBasedAvatar]="false"
				[items]="assignedTasks()"
				[disableSort]="true"
				[noItemsText]="'You have no assigned tasks'"
			></lib-list>
		</lib-card>

		<lib-card class="push-top-md" [title]="'Files'" [titleSuffix]="'(' + assignedFiles()?.length + ')'">
			<lib-list
				[showNameBasedAvatar]="true"
				[items]="assignedFiles()"
				[noItemsText]="'You have no assigned files'"
			></lib-list>
		</lib-card>
	</div>

	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		@if (showBrandInfo() && brandInfoBoxLocation() === 'right') {
		<div class="push-bottom-md">
			<ng-template [ngTemplateOutlet]="brandInfoTemplate"></ng-template>
		</div>
		}

		<lib-card [title]="'Upcoming appointments'" [titleSuffix]="'(' + upcomingAppointments()?.length + ')'">
			<lib-list
				[showNameBasedAvatar]="false"
				[items]="upcomingAppointments()"
				[disableSort]="true"
				[noItemsText]="'You have no upcoming appointments'"
			></lib-list>
		</lib-card>
	</div>
</div>
